import React, { FunctionComponent } from 'react'
import { StyleSheet, Text, View, TextInput } from 'react-native';
import Collapsible from 'react-native-collapsible';
import MyCheckbox from '../MyCheckbox';
import MyPicker from '../MyPicker';
import MyText from '../MyText';
import MyTextarea from '../MyTextarea';
import MyTextInput from '../MyTextInput';
import stylesheet from '../Style'

const ContactPerson = (props) => {
    const css = stylesheet();
    
    const [fName, setFName] = React.useState('');
    const [lName, setLName] = React.useState('');
    const [profession, setProfession] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');

    React.useEffect(() => {
        props.onChange({
            fName,
            lName,
            profession,
            email,
            phone
        });
    }, [fName, lName, profession, email, phone]);

    return (
        <View style={styles.externalContainer}>
            <MyText style={[css.m, styles.title]}>
                Contact Person
            </MyText>
            <View style={styles.container}>
                <View style={[{zIndex: 10}, css.formRow]}>
                    <MyText style={css.formRowLabel}>
                        First Name
                    </MyText>
                    <MyTextInput
                        style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                        onChangeText={setFName}
                        value={fName}
                    />
                </View>
                <View style={[{zIndex: 9}, css.formRow]}>
                    <MyText style={css.formRowLabel}>
                        Last Name
                    </MyText>
                    <MyTextInput
                        style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                        onChangeText={setLName}
                        value={lName}
                    />
                </View>
                <View style={[{zIndex: 9}, css.formRow]}>
                    <MyText style={css.formRowLabel}>
                        Profession
                    </MyText>
                    <MyTextInput
                        style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                        onChangeText={setProfession}
                        value={profession}
                    />
                </View>
                <View style={[{zIndex: 9}, css.formRow]}>
                    <MyText style={css.formRowLabel}>
                        Email
                    </MyText>
                    <MyTextInput
                        style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                        onChangeText={setEmail}
                        value={email}
                        inputMode='email'
                        keyboardType='email-address'
                    />
                </View>
                <View style={[{zIndex: 9}, css.formRow]}>
                    <MyText style={css.formRowLabel}>
                        Phone
                    </MyText>
                    <MyTextInput
                        inputMode='decimal'
                        keyboardType='phone-pad'
                        style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                        onChangeText={setPhone}
                        value={phone}
                    />
                </View>
            </View>
        </View>
    )
}
const styles = StyleSheet.create({
    externalContainer: {
        // paddingBottom: 10,
        // borderColor: '#532b75',
        // borderWidth: 1,
        // borderRadius: 20,
        // marginBottom: 15,
        flex: 1
    },
    container: {
        // paddingVertical: 10,
        // paddingHorizontal: 20,
        // paddingBottom: 0,
        // flex: 1
    },
    title: {
        color: '#461b6f',
        paddingVertical: 15,
        // paddingHorizontal: 20,
        // borderColor: '#461b6f',
        // borderBottomWidth: 1,
        // width: '60%'
    },
})
export default ContactPerson